<div class="m-3">
  <div class="m-3">
    <p class="">
      Send invitation to project
    </p>
    <form>
      <p>Type e-mail</p>
      <input class="form-control form-control-sm input-sm" type="text" placeholder="user e-mail" [(ngModel)]="email" name="email" (keydown.enter)="addUser()">
    </form>
  </div>
  <div class="m-3">
    <div class="btn-group" role="group">
    <button class="btn btn-outline-secondary" mat-dialog-close>
      <i class="bi bi-x" data-bs-toggle="tooltip" data-bs-placement="top" title="Close window" data-bs-delay="{show: 1000}"></i>
      Close
    </button>
    <button class="btn btn-outline-secondary" (click)="addUser()">
      <i class="bi bi-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send invitation" data-bs-delay="{show: 1000}"></i>
      Send
    </button>
  </div>
</div>